export default __webpack_public_path__ + "static/media/014_photo.9a39c738.jpg";